import { createGenericFormSlice, SliceState } from "./genericFormSlice";

export interface CloneVentState {
  name: string;
  starts: string;
  cloneGuests: boolean;
  cloneActivities: boolean;
}
const formSlice = createGenericFormSlice({
  name: "cloneVent",
  initialState: {} as SliceState<CloneVentState>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const cloneVentReducer = formSlice.reducer;
export default cloneVentReducer;
